$shm_ba_chart_tags $mol_view
	rows /
	sub /
		<= Chart $shm_echarts
			option <= option null
